import { Accordion, AccordionDetails, AccordionSummary, Tooltip, Typography } from "@mui/material";
import React from "react";
import { TableColumn } from "react-data-table-component";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import ProfileServices from "../../Services/ProfileServices";
import Swal from "sweetalert2";
import DataGrid from "../../Components/DataGrid/DataGrid";
import { amountFormat } from "../../Components/helper";
import html2pdf from 'html2pdf.js';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Column } from "react-data-grid";
import DataGridV2 from "../../Components/DataGridV2/DataGridV2";
import 'react-data-grid/lib/styles.css';

import './CSEDDetails.css';


interface IBasicChart {
    examinationActive: boolean,
    extensionDate: string,
    isExtensionActive: boolean,
    isLienActive: boolean,
    isReturnFiled: boolean,
    isCollectionActive: boolean,
    lienFiledDate: string,
    assessedBal: string,
    total: string,
    filingStatus: string,
    year: string,
    accruedBalance: string,
    assesseddBalance: string,
    csed: string,
    remainingMonths: string
}

export interface IBaseCSED {
    code: string;
    explanation: string;
    cycle: string;
    date: string;  // format: "MM-DD-YYYY"
    amount: number;
    originalIndex: number;
    estimatedStatute: string;
    remainingMonths: string;
    taxYear: string

}

interface IAssessments {
    year: string,
    baseCSED: IBaseCSED[]
}




interface ICSEDDetailsState {
    accessToken: string,
    baseCsed: IBaseCSED[],
    basicChart: IBasicChart[],
    isUpdateRequired: boolean;
    selectedYear: string,
    isNewRequired: boolean,
    currentHtml: string,
    assessmentDetails: IAssessments[]
}

class CSEDDetails extends React.Component<{ userId: string, userName: string }, ICSEDDetailsState> {

    constructor(props: any) {
        super(props);
        this.state = {

            accessToken: '',
            baseCsed: [],
            basicChart: [],
            isUpdateRequired: false,
            isNewRequired: false,
            selectedYear: '',
            currentHtml: '',
            assessmentDetails: []


        }
    }


    private basicChartcolumnsV2: Column<IBasicChart>[] = [
        { key: 'year', name: 'Year', renderCell: ({ row }) => (row.year) },
        { key: 'filingStatus', name: 'Filing Status', renderCell: ({ row }) => (row.filingStatus) },
        { key: 'isReturnFiled', name: 'Return Filed', renderCell: ({ row }) => row.isReturnFiled ? 'Yes' : 'No' },
        { key: 'isLienActive', name: 'Lien Active', renderCell: ({ row }) => row.isLienActive ? 'Yes' : 'No' },
        { key: 'isCollectionActive', name: 'Collection Active', renderCell: ({ row }) => row.isCollectionActive ? 'Yes' : 'No' },
        {
            key: 'accruedBalance', name: 'Accrued Balance ($)', cellClass: 'text-right',
            renderCell: ({ row }) => { return row.assesseddBalance }
        },
        {
            key: 'assesseddBalance', name: 'Assessed Balance ($)',  cellClass: 'text-right',
            renderCell: ({ row }) => { return row.assesseddBalance }
        },
        {
            key: 'csed', name: 'Earliest CSED',
            renderCell: ({ row }) => (row.csed),
        },
        {
            key: 'remainingMonths',
            name: 'Remaining Months', cellClass: 'text-right',
            renderCell: ({ row }) => (row.remainingMonths)
        },
        {
            key: 'action',
            name: 'Action',
            width: 120,
            sortable: false,
            renderCell: ({ row }) => (
                <button
                    onClick={() => {
                        this.setState({ isNewRequired: false, selectedYear: row.year }, () => {
                            this.getTranscriptFile();
                        })
                    }}
                    style={{
                        padding: '4px 8px',
                        cursor: 'pointer'
                    }}
                >
                    View Transcript
                </button>
            )
        }
    ];



    private basicChartFormColumns: TableColumn<IBasicChart>[] = [
        {
            name: 'Year',
            maxWidth: '75px',
            selector: (row: IBasicChart) => row.year,
            wrap: false
        },
        {
            name: 'Filing Status',
            cell: (row: IBasicChart) => (
                <div>
                    <Tooltip title={row.filingStatus}>
                        <div style={{ textAlign: 'left' }}>{row.filingStatus}</div>
                    </Tooltip>
                </div>
            ),
            wrap: false,
            

        },
        {
            name: 'Return Filed',
            maxWidth: '100px',
            selector: (row: IBasicChart) => row.isReturnFiled ? 'Yes' : 'No',
            wrap: false

        },
        // {
        //   name: 'Extension Active',
        //   maxWidth: '100px',
        //   selector: (row: IBasicChart) => row.isExtensionActive ? 'Yes' : 'No',
        //   wrap: false
        // },
        // {
        //   name: 'Extension Date',
        //   maxWidth: '120px',
        //   selector: (row: IBasicChart) => row.extensionDate ? row.extensionDate : 'NA',
        //   wrap: false,
        // },
        {
            name: 'Lien Active',
            maxWidth: '100px',
            selector: (row: IBasicChart) => row.isLienActive ? 'Yes' : 'No',
            wrap: false
        },
        // {
        //     name: 'Lien Filed Date',
        //     maxWidth: '120px',
        //     selector: (row: IBasicChart) => row.lienFiledDate ? row.lienFiledDate : 'NA',
        //     wrap: false
        // },
        {
            name: 'Collection Active',
            maxWidth: '100px',
            selector: (row: IBasicChart) => row.isCollectionActive ? 'Yes' : 'No',
            wrap: false
        },
        {
            name: 'Assessed Balance',
            maxWidth: '125px',
            selector: (row: IBasicChart) => { return row.assesseddBalance; },
            wrap: true,
            right: true
        },
        {
            name: 'Accrued Balance',
            maxWidth: '125px',
            selector: (row: IBasicChart) => { return row.accruedBalance; },
            wrap: true,
            right: true
        },
        {
            name: 'Earliest CSED',
            maxWidth: '120px',
            selector: (row: IBasicChart) => row.csed,
            wrap: true,
        },
        {
            name: 'Remaining months',
            maxWidth: '100px',
            selector: (row: IBasicChart) => row.remainingMonths,
            wrap: true,
            right: true
        },
        {
            name: 'View Transcript',
            // selector: (row: IEachYearDetails) => row.basicChart.examinationActive ? 'Yes' : 'No',
            cell: (row: IBasicChart) => <button
                className='download-form-Btn' style={{ whiteSpace: 'nowrap' }}
                onClick={(event) => {
                    this.setState({ isNewRequired: false, selectedYear: row.year }, () => {
                        this.getTranscriptFile();
                    })
                }}>
                View Transcript
            </button>,
            allowOverflow: true,


            button: true,
        }

    ];

    private csedColumns: TableColumn<IBaseCSED>[] = [
        {
            name: 'Code',
            maxWidth: '80px',
            selector: (row: IBaseCSED) => row.code,
            wrap: false
        },
        {
            name: 'Description ',
            maxWidth: '350px',
            selector: (row: IBaseCSED) => row.explanation,
            cell: (row: IBaseCSED) => (
                <Tooltip title={row.explanation}>
                    <div>{row.explanation}</div>
                </Tooltip>
            ),
            wrap: false
        },
        {
            name: 'Cycle',
            maxWidth: '120px',
            selector: (row: IBaseCSED) => row.cycle,
            cell: (row: IBaseCSED) => (
                <Tooltip title={row.cycle}>
                    <div>{row.cycle}</div>
                </Tooltip>
            ),
            wrap: false
        },

        {
            name: 'Date',
            maxWidth: '120px',
            selector: (row: IBaseCSED) => row.date,
            wrap: false
        },
        {
            name: 'Amount',
            maxWidth: '120px',
            selector: (row: IBaseCSED) => row.amount,
            cell: (row: IBaseCSED) => <div style={{
                width: '100%',
                textAlign: 'center'
            }}> {amountFormat(row.amount, 'en-US', 'USD')}</div>,
            wrap: false
        },
        {
            name: 'Estimated CSED',
            maxWidth: '120px',
            selector: (row: IBaseCSED) => row.estimatedStatute.split('T')[0],
            wrap: false
        },
        {
            name: 'Remaining Months',
            maxWidth: '120px',
            selector: (row: IBaseCSED) => {
                if (row.date && row.estimatedStatute.toLowerCase() != 'na') {
                    const startDate = new Date();
                    const endDate = new Date(row.estimatedStatute);

                    return endDate.getMonth() -
                        startDate.getMonth() +
                        12 * (endDate.getFullYear() - startDate.getFullYear());
                }
                return 'NA';
            },
            wrap: false
        },
        // {
        //   maxWidth: '50px',
        //   cell: row => <CustomMaterialMenu
        //     fontSize="small"
        //     multiPopoverItems={[
        //       {
        //         key: "added",
        //         label: "Transactions Added",
        //       },
        //       {
        //         key: "deducted",
        //         label: "Transactions Deducted",
        //       },
        //       {
        //         key: "sameDate",
        //         label: "Transactions Assessed On Same Date",
        //       }
        //     ]}
        //     onPopoverClick={(key_: string, label_: string) => {
        //      // this.openAdditionalCSEDInfo(row, key_, label_);
        //     }} />,

        //   allowOverflow: true,
        //   button: true,
        //   width: '56px'
        // }
    ];

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getReportDashboard()
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    getTranscriptFile = () => {
        try {
            let payload = {
                isnewRequired: this.state.isNewRequired,
                userId: this.props.userId,
                taxYear: this.state.selectedYear
            };
           
            ProfileServices.downloadTranscript(payload, this.state.accessToken).then((r) => {
                if (r.ok) {
                    r.json().then(resp => {
                        console.log(resp);
                        if (resp[0].isUpdateRequired == 1) {
                            this.setState({ isUpdateRequired: true, currentHtml: resp[0].html })
                        }
                        else {
                            this.openHtmlAsPdf(resp[0].html);

                        }
                    }, () => {
                        ///... post execution once state is set
                    }).catch(err => {
                        Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
                    });



                }
            });
        }
        catch (ex) {
            console.error(ex);
        }

    }

    confirmOverlay = () => {
        return (
            <div className="confirm-backdrop">
                <div className="confirm-card">
                    <h4>Confirm action</h4>
                    <p>This transcript is more than a week old.
                        Would you like to fetch the latest version now?</p>

                    <div className="actions">
                        <button className="btn yes" onClick={() => {
                            this.setState({ isNewRequired: true, isUpdateRequired: false }, () => {
                                this.getTranscriptFile();
                            })
                        }}>Yes</button>
                        <button className="btn no" onClick={() => { this.openHtmlAsPdf(this.state.currentHtml); this.setState({ isUpdateRequired: false }) }}>No</button>
                    </div>
                </div>
            </div>
        );
    };

    getReportDashboard = () => {
        ProfileServices.getReportDashboard(this.props.userId, this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({
                        basicChart: resp.data.map((x: { basicChart: any; }) => x.basicChart),
                        baseCsed: [...this.state.baseCsed, ...resp.data.flatMap((x: { baseCSED: any }) => x.baseCSED)],
                        assessmentDetails: resp.data.map((x: any) => {
                            return {
                                year: x.year,
                                baseCSED: x.baseCSED
                            }
                        })
                    }, () => {
                        console.log(this.state)
                    })
                    // this.setState({ allYearDetails: resp });
                }, () => {
                    ///... post execution once state is set
                }).catch(err => {
                    Swal.fire("Error", err.message ? err.message : 'Failed due to technical difficulties', "error");
                });



            }
        });
    }

    renderBaseCSEDEachYear() {
        try {
            return this.state.assessmentDetails.map((item) => (


                <Accordion>

                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header">
                        <Typography component="span">{item.year}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div className='body-sub-contianer table-container'>
                                <DataGrid
                                    columns={this.csedColumns}
                                    data={item.baseCSED
                                    }
                                />
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            )
            )

        }
        catch (ex) {

        }
    }


    renderBasicChart() {
        try {

            return (
                <div className='body-sub-contianer table-container' style={{ marginTop: '10px' }}>
                    <DataGrid
                        columns={this.basicChartFormColumns}
                        data={this.state.basicChart}
                        title="Tax Summary"
                        
                    />

                    {/* <DataGridV2
                        columns={this.basicChartcolumnsV2}
                        rows={this.state.basicChart}
                        height={20}
                        draggable={true}
                        resizable={true}
                    /> */}
                </div>
            )
        }
        catch (ex) {

        }
    }
    public render() {
        return <>

            
            {this.state.isUpdateRequired && this.confirmOverlay()}
            <h3 style={{ textAlign: 'center' }}>{this.props.userName}</h3>

            {this.renderBasicChart()}

            <h1 style={{ textAlign: 'left' }}>Assessment Details</h1>
            {this.renderBaseCSEDEachYear()}
        </>
    }

    openHtmlAsPdf = (htmlString: string) => {
        const element = document.createElement('div');
        element.innerHTML = htmlString;

        const options = {
            margin: 10,
            filename: 'document.pdf',
            image: { type: 'jpeg' as const, quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm' as const, format: 'a4' as const, orientation: 'portrait' as const }
        };

        html2pdf()
            .set(options)
            .from(element)
            .outputPdf('bloburl')
            .then((pdfUrl: any) => {
                window.open(pdfUrl, '_blank');
            });
    };
}






export default CSEDDetails;